import React from 'react';
import PropTypes from 'prop-types';
import { OpenInNew, FileCopy } from '@material-ui/icons';

import {
  BiometricContainer,
  BiometricIdentification,
  BiometricLinksContainer,
  BiometricLink,
  BiometricStatus,
} from './style';

const biometricProviderBaseUrl = 'https://app.passbase.com/?id=';
const approvedStatus = 'approved';

const Biometric = ({
  status, providerId, clickHandler,
}) => (
  <BiometricContainer>
    <BiometricIdentification>
      Identification:
      {' '}
      <BiometricStatus status={status}>{status || 'Not available'}</BiometricStatus>
    </BiometricIdentification>
    <BiometricLinksContainer>
      {providerId && (
        <BiometricLink
          data-testid="link.biometric-provider-backoffice"
          href={`${biometricProviderBaseUrl}${providerId}`}
          target="_blank"
        >
          <OpenInNew />
          See details
        </BiometricLink>
      )}
      {status !== approvedStatus && (
        <BiometricLink
          data-testid="link.copy-biometric-url"
          onClick={clickHandler}
        >
          <FileCopy />
          Copy URL
        </BiometricLink>
      )}
    </BiometricLinksContainer>
  </BiometricContainer>
);

Biometric.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  status      : PropTypes.string,
  providerId  : PropTypes.string,
};

Biometric.defaultProps = {
  status    : undefined,
  providerId: undefined,
};

export default Biometric;
